let season_standings,
    ss_section = $('.pbl-standings'),
    ss_data;

//Return the date and time the season standings were updated.
function formatStandingDate(d, week) {
  let date = new Date(d);
      month = date.toLocaleDateString('default', {month: 'long'}),
      day = date.toLocaleDateString('default', {weekday: 'long'}),
      hour = (((date.getHours()) + 11) % 12 + 1) + 2, // Convert military time to standard. 
      weekday = date.getDate();

      //Format the day & month: "tuesday"->"tue" || "April"->"Apr"
      if(day && month) {
        let parsed_day = day.split(""),
            parsed_month = month.split("");
        
        day = parsed_day.slice(0,3).toString().replaceAll(",", "");
        month = parsed_month.slice(0,3).toString().replaceAll(",", "");
      }

  return `As of ${day} ${month} ${weekday} @ ${hour}PM (after week ${week})`;
}

// Retrieve All Season Standings data
function getSeasonStandings() {
  $.ajax({ 
      url: 'https://tnp.mysites.io/wp-json/pbl/v1/all-season-standings',
      dataType: 'text'
  })
  .done((res) => {
      season_standings = JSON.parse(res);
      init_season_standings();
  })
  .fail((res) => {
      console.log('Failed to retrieve All Season Standings Data!');
  })
}

getSeasonStandings();

// Sorts the seasons standings array.
function ss_sort(arr) {
  ss_arr1 = [];
  ss_arr2 = [];
  ss_arrays = [];
  
  for(let j = 0; j < arr.length; j++) {
    if(arr[j]['season'] === 'season-2'){
      ss_arr2.push(arr[j]);
    } else if(arr[j]['season'] === 'season-1') {
      ss_arr1.push(arr[j]);
    }
  }

  ss_arrays.push(ss_arr2, ss_arr1);

  console.log("New SS_array: ", ss_arrays);
  return ss_arrays;
}

// Used to dynamically create the season standings from data sent from the TNP Web App.
function dynamicSeasonStandings() {
  ss_data = ss_sort(season_standings);
  for(let i = 0; i < ss_data.length; i++) {
     // Initalize the the first row and latest season standing rows
     if(i === 0) {
       ss_init(i);
     }

     // Allow users to select the season they want to see, and change the standings according to their choice.
     $('#ss_selector').change(()=>{
       if($(`#ss_selector option:selected`).val() === `season--${(ss_data.length) - i}`){
         ss_table(i); 
       }
     });
  }
}

//A function that will initalize the season selctor for the season standings and create the latest season data.
function ss_init(i) {
  ss_section.append(
    `<div class="row pbl-standings__row--top">`+
      `<h2 class="text-center">Regular Season Results</h2>`+
      `<p> ${formatStandingDate(season_standings[5]['event-date'], season_standings[5]['week'])} </p>`+
       `<nav class="pbl-standings__row--selector">`+
        `<div class="custom-select">`+
          `<label class="sr-only">Choose your TNP season:</label>`+
          `<span class="custom-arrow"></span>`+
          `<select id="ss_selector">`+
            `<option class="ssb_1" value="season--1">Season 1</option>`+
            `<option class="ssb_2" value="season--2" selected="true">Season 2</option>`+
          `</select>`+
        `</div>`+
      `</nav>`+
    `</div>`
  ); 

  ss_table(i);
}

// A function will create the season standings tables.
function ss_table(i) {
  /**** Functionality ****/
  //Remove any old rows in the season standings table.
  $('.pbl-standings .table_row').remove(); 
  
  /**** Interface ****/
  // Second part of the table (Rows 2 to 5)
  ss_section.append(
    `<div class="row table_row table_row--1">` +
          `<div class="sm-col-1 col-1">`+`<h3 class="text-center">Place</h3>`+`</div>`+
          `<div class="sm-col-3 col-4">`+`<h3>Team</h3>`+`</div>`+
          `<div class="sm-col-1 col-1">`+`<h3 class="text-center">Wins</h3>`+`</div>`+
          `<div class="sm-col-1 col-1">`+`<h3 class="text-center">Losses</h3>`+`</div>`+
          `<div class="sm-col-1 col-1">`+`<h3 class="text-center sm-hide">Point Differential</h3>`+`<h3 class="text-center sm-only">Point Diff.</h3>`+`</div>`+
          `<div class="sm-col-1 col-1">`+`<h3 class="text-center">Points For</h3>`+`</div>`+
          `<div class="sm-col-1 col-1 sm-hide">`+`<h3 class="text-center">Points Against</h3>`+`</div>`+
    `</div>`+
    `<div class="row table_row table_row--2">` +
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][0]['place']}</p>`+`</div>`+
      `<div class="sm-col-3 col-4">`+`<p>${ss_data[i][0]['team_name']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][0]['wins']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][0]['losses']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center sm-hide">${ss_data[i][0]['point_differential']}</p>`+`<p class="text-center sm-only">${ss_data[i][0]['point_differential']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][0]['points_for']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1 sm-hide">`+`<p class="text-center">${ss_data[i][0]['points_against']}</p>`+`</div>`+
    `</div>`+
    `<div class="row table_row table_row--3">` +
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][1]['place']}</p>`+`</div>`+
      `<div class="sm-col-3 col-4">`+`<p>${ss_data[i][1]['team_name']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][1]['wins']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][1]['losses']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center sm-hide">${ss_data[i][1]['point_differential']}</p>`+`<p class="text-center sm-only">${ss_data[i][1]['point_differential']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][1]['points_for']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1 sm-hide">`+`<p class="text-center">${ss_data[i][1]['points_against']}</p>`+`</div>`+
    `</div>`+
    `<div class="row table_row table_row--4">` +
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][2]['place']}</p>`+`</div>`+
      `<div class="sm-col-3 col-4">`+`<p>${ss_data[i][2]['team_name']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][2]['wins']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][2]['losses']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center sm-hide">${ss_data[i][2]['point_differential']}</p>`+`<p class="text-center sm-only">${ss_data[i][2]['point_differential']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][2]['points_for']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1 sm-hide">`+`<p class="text-center">${ss_data[i][2]['points_against']}</p>`+`</div>`+
    `</div>`+
    `<div class="row table_row table_row--5">` +
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][3]['place']}</p>`+`</div>`+
      `<div class="sm-col-3 col-4">`+`<p>${ss_data[i][3]['team_name']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][3]['wins']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][3]['losses']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center sm-hide">${ss_data[i][3]['point_differential']}</p>`+`<p class="text-center sm-only">${ss_data[i][3]['point_differential']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][3]['points_for']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1 sm-hide">`+`<p class="text-center">${ss_data[i][3]['points_against']}</p>`+`</div>`+
    `</div>`+
    `<div class="row table_row table_row--6">` +
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][4]['place']}</p>`+`</div>`+
      `<div class="sm-col-3 col-4">`+`<p>${ss_data[i][4]['team_name']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][4]['wins']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][4]['losses']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center sm-hide">${ss_data[i][4]['point_differential']}</p>`+`<p class="text-center sm-only">${ss_data[i][4]['point_differential']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1">`+`<p class="text-center">${ss_data[i][4]['points_for']}</p>`+`</div>`+
      `<div class="sm-col-1 col-1 sm-hide">`+`<p class="text-center">${ss_data[i][4]['points_against']}</p>`+`</div>`+
    `</div>`
  );

  // If the user selects any season than season 1, the playoffs will be hidden.
  if($(`#ss_selector option:selected`).val() === `season--2`) {
    $('.playoffs-title.playoffs_title--s1').hide();
    $('.pbl-standings__row--top__playoff-img.playoffs_img--s1').hide();
    
    ss_section.append(
      `<h2 class="text-center playoffs-title playoffs_title--s2">Season 2 Playoffs</h2>`+
      `<img src="https://cdn.shopify.com/s/files/1/0286/5666/4654/files/azpbl_playoff-s2-wk3.png?v=1703045227" alt="TNP AZPBL Season 2 playoffs" class="text-center pbl-standings__row--top__playoff-img playoffs_img--s2"/>`
    );
  } else {
    //Else if the user selects season 1, the playoffs will be created and show below the season standings table.
    $('.playoffs-title.playoffs_title--s2').hide();
    $('.pbl-standings__row--top__playoff-img.playoffs_img--s2').hide();
    
    ss_section.append(
      `<h2 class="text-center playoffs-title playoffs_title--s1">Season 1 Playoffs</h2>`+
      `<img src="https://cdn.shopify.com/s/files/1/0286/5666/4654/files/azpbl-playoff-bracket-v5a.png?v=1685550358" alt="TNP AZPBL Season 1 playoffs" class="text-center pbl-standings__row--top__playoff-img playoffs_img--s1"/>`
    );
  }
}

// Populate the latest season first.
function init_season_standings() {
  dynamicSeasonStandings();  
}